import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { IconSizes } from '../../components/foundations/Icon';
import tableCss from '../../components/organisms/Table.css';
import { Label } from '../../components/widgets';
import CellLoader from '../../components/widgets/CellLoader';
import { deriveSectionsAccess } from '../../selectors/navigation';
import { SECTIONS_PAGES_CONFIG } from '../sections';
import { SectionPermissionSchema } from '../types';
import { translationPrefix as translationRootPrefix, CUSTOM_ACCESS_TYPE } from '../utils';
import css from './PermissionsCell.css';
import AccessTypeIcon, { ICON_VARIANTS_BY_ACCESS_TYPE } from './AccessTypeIcon';

const translationPrefix = `${translationRootPrefix}.MANAGE_PERMISSIONS_PAGE`;

const PermissionsCell = ({ key, isLoading, sectionPermissions, loaderClass = '' }) => {
    const renderStep = ({ step, cards }) => {
        const sectionNames = cards.flatMap(card => card.parts.flatMap(part => part.sectionNames));
        const featureAccess = deriveSectionsAccess(
            sectionPermissions.filter(({ name }) => sectionNames.includes(name))
        );
        const accessType = featureAccess.isSingleAccessLevel ? featureAccess.accessType : CUSTOM_ACCESS_TYPE;

        return (
            <div className={classNames(css.stepContainer, css[ICON_VARIANTS_BY_ACCESS_TYPE[accessType]])}>
                <AccessTypeIcon accessType={accessType} size={IconSizes.X_SMALL} wrapperClass={css.accessTypeIcon} />
                <Label text={`${translationPrefix}.TABS.${step.toUpperCase()}`} className={css.stepLabel} />
            </div>
        );
    };

    return (
        <td className={tableCss.rowIndexCell} key={key}>
            {isLoading ? (
                <CellLoader loaderClass={loaderClass} />
            ) : (
                <div className={css.cellContent}>{SECTIONS_PAGES_CONFIG.map(renderStep)}</div>
            )}
        </td>
    );
};

PermissionsCell.propTypes = {
    key: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    sectionPermissions: PropTypes.arrayOf(SectionPermissionSchema).isRequired,
    loaderClass: PropTypes.string,
};

export default PermissionsCell;
